import Loader from './generic/Loader';

import styles from './BrandedLoadingScreen.module.less';

/**
 * Full-viewport, non-interactive loading screen. Used to block the app shell
 * while a synchronous decision is pending (e.g. `SurveyProvider` waits for
 * PostHog to deliver the onboarding survey content). No interactive controls;
 * the gate component swaps it out when its decision lands.
 */
export const BrandedLoadingScreen = () => {
  return (
    <div className={styles.container} data-testid="branded-loading-screen">
      <Loader />
    </div>
  );
};
